import { BSpinner } from './spinner';
import { pluginFactory } from '../../utils/plugins';
var SpinnerPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BSpinner: BSpinner
  }
});
export { SpinnerPlugin, BSpinner };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/spinner/index.js
// module id = ./node_modules/bootstrap-vue/esm/components/spinner/index.js
// module chunks = 1